import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './header.style.scss'

function LanguageSwitcher() {
    const navigate = useNavigate();
    const location = useLocation();

    const switchToLanguage = (newLang, event) => {
        event.preventDefault();
        const currentPath = location.pathname;
        const pathSegments = currentPath.split('/');
        pathSegments[1] = newLang;
        const newPath = pathSegments.join('/');
        navigate(newPath);
    };

    const langLink = (lang) => {
        const currentPath = location.pathname;
        const pathSegments = currentPath.split('/');
        pathSegments[1] = lang;
        const newPath = pathSegments.join('/');
        return newPath
    }

    return (
        <div className="lang-switcher-wrap" style={{ textAlign: 'right' }}>
            <Link className="menuLink lang-flag" to={langLink("en")} onClick={(e) => switchToLanguage('en', e)} aria-label="English" title="English">
                <img src="https://flagcdn.com/w40/gb.png" alt="" width="24" height="18" className="lang-flag-img" />
            </Link>
            <span className="lang-sep" aria-hidden="true"> </span>
            <Link className="menuLink lang-flag" to={langLink("ru")} onClick={(e) => switchToLanguage('ru', e)} aria-label="Русский" title="Русский">
                <img src="https://flagcdn.com/w40/ru.png" alt="" width="24" height="18" className="lang-flag-img" />
            </Link>
        </div>
    );
}

export default LanguageSwitcher;